import { Col, Form } from "antd";
import { Box, HeaderOverview } from "components";
import { useOverview } from "providers/overview";
import React from "react";
import { useTranslation } from "react-i18next";
import { useGetPropertyDashBoardComplaint } from "service/dashboard/property/recommrnt-feed-back";
import { LoadingDashboard } from "../..";

export const StatusBox = () => {
  const { t } = useTranslation();
  const { findDate } = useOverview();

  const statusComplaintsDate = Form.useWatch("statusComplaintsDate");
  const date = findDate(statusComplaintsDate);
  const { data, isFetching } = useGetPropertyDashBoardComplaint({...date});

  return (
    <React.Fragment>
      <Col md={24} lg={24} xl={24}>
        <HeaderOverview
          title={t("property.complaint", { ns: "menu" })}
          name="statusComplaintsDate"
        />
      </Col>
      <Col md={24} lg={8} xl={8}>
        <LoadingDashboard loading={isFetching}>
          <Box
            title={t("number-complaints")}
            count={0}
            color="blue"
            textAfter={false}
            isGrid={true}
            appealTotal={
              data?.find((item) => item.status === "ALL")?.category?.APPEAL ?? 0
            }
            suggestTotal={
              data?.find((item) => item.status === "ALL")?.category?.SUGGEST ??
              0
            }
            feedbackTotal={
              data?.find((item) => item.status === "ALL")?.category?.FEEDBACK ??
              0
            }
          />
        </LoadingDashboard>
      </Col>
      <Col md={24} lg={8} xl={8}>
        <LoadingDashboard loading={isFetching}>
          <Box
            title={t("number-pending-complaints")}
            count={0}
            color={"yellow"}
            textAfter={false}
            isGrid={true}
            appealTotal={
              data?.find((item) => item.status === "PENDING")?.category
                ?.APPEAL ?? 0
            }
            suggestTotal={
              data?.find((item) => item.status === "PENDING")?.category
                ?.SUGGEST ?? 0
            }
            feedbackTotal={
              data?.find((item) => item.status === "PENDING")?.category
                ?.FEEDBACK ?? 0
            }
          />
        </LoadingDashboard>
      </Col>
      <Col md={24} lg={8} xl={8}>
        <LoadingDashboard loading={isFetching}>
          <Box
            title={t("number-completed-complaints")}
            count={0}
            color="green"
            textAfter={false}
            isGrid={true}
            appealTotal={
              data?.find((item) => item.status === "SUCCESS")?.category
                ?.APPEAL ?? 0
            }
            suggestTotal={
              data?.find((item) => item.status === "SUCCESS")?.category
                ?.SUGGEST ?? 0
            }
            feedbackTotal={
              data?.find((item) => item.status === "SUCCESS")?.category
                ?.FEEDBACK ?? 0
            }
          />
        </LoadingDashboard>
      </Col>
    </React.Fragment>
  );
};
